import { IPoll } from "~contexts/Socket/interfaces";

export interface IPollContext {
  polls: IPoll[];
  setPolls: (polls: IPoll[]) => void;
  isEditing: boolean;
  setIsEditing: (value: boolean) => void;
  onCreatePoll: (newPoll: any) => void;
  onFinishPoll: (id: number) => void;
  onRefreshPolls: () => void;
  setPollActive: (value: number) => void;
}

export const DEFAULT_POLL_DATA = {
  polls: [],
  setPolls: () => {},
  isEditing: false,
  setIsEditing: () => {},
  onCreatePoll: () => {},
  onFinishPoll: () => {},
  onRefreshPolls: () => {},
  setPollActive: () => {},
};
